import React, {Component} from "react"
import {translate} from "translate"
import shop from "../../shop/shop"
import {Button} from "elemental"
import app from "../../app.controller"
import Price from "../Price/Price"
import config from "config"
import { observer } from "mobx-react";

@observer
export default class CartButton extends Component {

  constructor() {
    super()
    this.state = {
      sum: 0
    }
  }

  componentDidMount() {
    this.cartListener = shop.cart.hooks.changed.add( this.updateCart )
    this.setState( {
      sum: shop.cart.sum
    } )
  }

  updateCart = ({ cart }) => {
    this.setState( {
      sum: cart.sum
    } )
  }

  componentWillUnmount() {
    shop.cart.hooks.changed.remove( this.updateCart )
  }

  render() {
    let { sum } = this.state
    return (
      <div className="fr tr">
        <Button style={{ paddingRight: 0 }} type="link" href="#"
                onClick={app.sidebar.toggle.dispatch}>
          <i className="icon-basket"/> &nbsp;
          <Price>{sum}</Price>
        </Button>
        <MinOrder sum={sum}/>
      </div>

    )
  }
}

class Mindestbestellwert extends Component {

  constructor() {
    super()
    this.state = {
      sum: 0
    }
  }

  componentDidMount() {
    this.cartListener = shop.cart.hooks.changed.add( this.updateCart )
    this.setState( {
      sum: shop.cart.sum
    } )
  }

  updateCart = ({ cart }) => {
    this.setState( {
      sum: cart.sum
    } )
  }

  componentWillUnmount() {
    shop.cart.hooks.changed.remove( this.updateCart )
  }

  render() {
    let { sum } = this.state
    return (
      <MinOrder sum={sum}/>
    )
  }
}

const MinOrder = ({ sum }) => {
  const ok = sum >= config.MIN_ORDER_VALUE
  if ( ok ) return <div className="f7">{translate( "min_order_value_ok" )}</div>
  if ( !ok ) return <div className="f7">{translate( "min_order_value" )} <Price>{Number(config.MIN_ORDER_VALUE)}</Price></div>
}

export {Mindestbestellwert}



// WEBPACK FOOTER //
// ./src/components/Cart/CartButton.js